import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { useMutation, useClient } from 'Data/Api.js'
import { useDataValue } from 'Simple/Data.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

import queryPatient from './query-patient.graphql.js'
import mutation from './mutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data, reExecuteQuery) {
  let location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location._id',
  })
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'message',
    path: 'params.patient_id',
  })
  let client = useClient()
  let setFlowTo = useSetFlowTo(props.viewPath)
  let [, createTreatmentMutation] = useMutation(mutation)
  let [, notify] = useNotifications()

  return async function onSubmit({ args, value, originalValue }) {
    let { data } = await client
      .query(queryPatient, { id: patient_id })
      .toPromise()
    let response = await createTreatmentMutation({
      patient_id: data?.vaxiom_patients_by_pk?._id,
      location_id,
    })

    if (response.error) {
      return notify(
        notifyError('An unexpected error has occurred creating a new treatment')
      )
    }

    setFlowTo(normalizePath(props.viewPath, '../../No'))

    return notify(
      notifySuccess('A new treatment has been successfully created')
    )
  }
}
